import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { Input } from "../../../../../_metronic/_partials/controls";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { getPartnerAll } from "../../../Partner/_redux/partnerCrud";
import { getDistributionNormalAll } from "../../../Distribution/Normal/_redux/normalCrud";

export function MergingListEditForm({ saveMerging }) {
  useEffect(() => {
    getDistributionNormalAll({ is_merging: false }).then((res) => {
      const {
        data: { list_area, list_livestock, list_partner },
      } = res;
      setOptions({
        partner: list_partner,
        livestock: list_livestock,
        area: list_area,
      });
    });
  }, []);

  const [options, setOptions] = useState({
    partner: [],
    area: [],
    livestock: [],
  });

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{}}
        onSubmit={(values) => saveMerging(values)}
      >
        {({ values, handleSubmit, setFieldValue }) => (
          <>
            <div className="form-group row">
              <div className="col">
                <label>Cari Hewan</label>
                <Autocomplete
                  name="thk_livestock_uuid"
                  options={options.livestock.filter(item => item.type === "KAMBING")}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("thk_livestock_uuid", value.uuid);
                    } else {
                      setFieldValue("thk_livestock_uuid", "");
                    }
                  }}
                  value={
                    options.livestock.length > 0 &&
                    options.livestock.find(
                      (option) => option.uuid === values.thk_livestock_uuid
                    )
                  }
                  loading={options.partner.length === 0 ? true : false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Hewan"
                      variant="outlined"
                      disableClearable
                      size="small"
                    />
                  )}
                />
              </div>
              <div className="col">
                <label>Cari Wilayah</label>
                <Autocomplete
                  name="thk_area_uuid"
                  options={options.area}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("thk_area_uuid", value.uuid);
                    } else {
                      setFieldValue("thk_area_uuid", "");
                    }
                  }}
                  value={
                    options.area.length > 0 &&
                    options.area.find(
                      (option) => option.uuid === values.thk_area_uuid
                    )
                  }
                  loading={options.area.length === 0 ? true : false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Wilayah"
                      variant="outlined"
                      disableClearable
                      size="small"
                    />
                  )}
                />
              </div>
              <div className="col">
                <label>Cari Mitra</label>
                <Autocomplete
                  name="thk_partner_uuid"
                  options={options.partner}
                  getOptionLabel={(option) => option.name}
                  onChange={(e, value) => {
                    if (value) {
                      setFieldValue("thk_partner_uuid", value.uuid);
                    } else {
                      setFieldValue("thk_partner_uuid", "");
                    }
                  }}
                  value={
                    options.partner.length > 0 &&
                    options.partner.find(
                      (option) => option.uuid === values.thk_partner_uuid
                    )
                  }
                  loading={options.partner.length === 0 ? true : false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Cari Mitra"
                      variant="outlined"
                      disableClearable
                      size="small"
                    />
                  )}
                />
              </div>
            </div>
            <div>
              <button
                className="btn btn-primary float-right"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </Formik>
    </>
  );
}
